import { classNames } from "helpers/classNames";

interface Props {
  className: string;
}

interface BatteryProps {
  className?: string;
  level: number | null;
}

export function IconBattery({ className, level }: BatteryProps) {
  if (level !== null) {
    if (level > 75) {
      return (
        <svg
          width="42"
          height="19"
          viewBox="0 0 42 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M36.283 1H3.953C2.84843 1 1.953 1.89543 1.953 3V15.176C1.953 16.2806 2.84843 17.176 3.953 17.176H36.283C37.3876 17.176 38.283 16.2806 38.283 15.176V3C38.283 1.89543 37.3876 1 36.283 1Z"
            stroke="#535353"
            strokeWidth="2"
          />
          <path d="M41.283 5.58801H39.283V12.588H41.283V5.58801Z" fill="white" />
          <path d="M40.283 6.58801V11.588V6.58801Z" stroke="#535353" strokeWidth="2" />
          <path
            d="M33.953 4H5.953C5.40072 4 4.953 4.44772 4.953 5V13.176C4.953 13.7283 5.40072 14.176 5.953 14.176H33.953C34.5053 14.176 34.953 13.7283 34.953 13.176V5C34.953 4.44772 34.5053 4 33.953 4Z"
            fill="#535353"
          />
        </svg>
      );
    } else if (level > 50) {
      return (
        <svg
          width="41"
          height="19"
          viewBox="0 0 41 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M35.613 1.17603H3.28296C2.17839 1.17603 1.28296 2.07146 1.28296 3.17603V15.352C1.28296 16.4566 2.17839 17.352 3.28296 17.352H35.613C36.7175 17.352 37.613 16.4566 37.613 15.352V3.17603C37.613 2.07146 36.7175 1.17603 35.613 1.17603Z"
            stroke="#535353"
            strokeWidth="2"
          />
          <path d="M40.613 5.76404H38.613V12.764H40.613V5.76404Z" fill="white" />
          <path d="M39.613 6.76404V11.764V6.76404Z" stroke="#535353" strokeWidth="2" />
          <path
            d="M27.283 4.17603H5.28296C4.73067 4.17603 4.28296 4.62374 4.28296 5.17603V13.352C4.28296 13.9043 4.73067 14.352 5.28296 14.352H27.283C27.8352 14.352 28.283 13.9043 28.283 13.352V5.17603C28.283 4.62374 27.8352 4.17603 27.283 4.17603Z"
            fill="#535353"
          />
        </svg>
      );
    } else if (level > 25) {
      return (
        <svg
          width="41"
          height="19"
          viewBox="0 0 41 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M35.943 1.35205H3.61304C2.50847 1.35205 1.61304 2.24748 1.61304 3.35205V15.5281C1.61304 16.6326 2.50847 17.5281 3.61304 17.5281H35.943C37.0476 17.5281 37.943 16.6326 37.943 15.5281V3.35205C37.943 2.24748 37.0476 1.35205 35.943 1.35205Z"
            stroke="#535353"
            strokeWidth="2"
          />
          <path d="M40.943 5.94006H38.943V12.9401H40.943V5.94006Z" fill="white" />
          <path d="M39.943 6.94006V11.9401V6.94006Z" stroke="#535353" strokeWidth="2" />
          <path
            d="M18.778 4.35205H5.61304C5.06075 4.35205 4.61304 4.79977 4.61304 5.35205V13.5281C4.61304 14.0803 5.06075 14.5281 5.61304 14.5281H18.778C19.3303 14.5281 19.778 14.0803 19.778 13.5281V5.35205C19.778 4.79977 19.3303 4.35205 18.778 4.35205Z"
            fill="#535353"
          />
        </svg>
      );
    } else if (level > 10) {
      return (
        <svg
          width="42"
          height="19"
          viewBox="0 0 42 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M36.273 1.52698H3.94299C2.83842 1.52698 1.94299 2.42241 1.94299 3.52698V15.703C1.94299 16.8075 2.83842 17.703 3.94299 17.703H36.273C37.3776 17.703 38.273 16.8075 38.273 15.703V3.52698C38.273 2.42241 37.3776 1.52698 36.273 1.52698Z"
            stroke="#535353"
            strokeWidth="2"
          />
          <path d="M41.273 6.11499H39.273V13.115H41.273V6.11499Z" fill="white" />
          <path d="M40.273 7.11499V12.115V7.11499Z" stroke="#535353" strokeWidth="2" />
          <path
            d="M11.943 4.52698H5.94299C5.39071 4.52698 4.94299 4.97469 4.94299 5.52698V13.703C4.94299 14.2553 5.39071 14.703 5.94299 14.703H11.943C12.4953 14.703 12.943 14.2553 12.943 13.703V5.52698C12.943 4.97469 12.4953 4.52698 11.943 4.52698Z"
            fill="#535353"
          />
        </svg>
      );
    } else if (level >= 0) {
      return (
        <svg
          width="41"
          height="19"
          viewBox="0 0 41 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames("animate-blink", className)}
        >
          <path
            d="M35.603 1.703H3.27295C2.16838 1.703 1.27295 2.59843 1.27295 3.703V15.879C1.27295 16.9836 2.16838 17.879 3.27295 17.879H35.603C36.7075 17.879 37.603 16.9836 37.603 15.879V3.703C37.603 2.59843 36.7075 1.703 35.603 1.703Z"
            stroke="#535353"
            strokeWidth="2"
          />
          <path d="M40.603 6.29102H38.603V13.291H40.603V6.29102Z" fill="white" />
          <path d="M39.603 7.29102V12.291V7.29102Z" stroke="#535353" strokeWidth="2" />
          <path
            d="M7.27295 4.703H5.27295C4.72066 4.703 4.27295 5.15072 4.27295 5.703V13.879C4.27295 14.4313 4.72066 14.879 5.27295 14.879H7.27295C7.82523 14.879 8.27295 14.4313 8.27295 13.879V5.703C8.27295 5.15072 7.82523 4.703 7.27295 4.703Z"
            fill="#FC6F6C"
          />
        </svg>
      );
    }
  }

  return (
    <svg
      width="41"
      height="20"
      viewBox="0 0 41 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M35.396 1.94299H3.06604C1.96147 1.94299 1.06604 2.83842 1.06604 3.94299V16.119C1.06604 17.2236 1.96147 18.119 3.06604 18.119H35.396C36.5006 18.119 37.396 17.2236 37.396 16.119V3.94299C37.396 2.83842 36.5006 1.94299 35.396 1.94299Z"
        stroke="#535353"
        strokeWidth="2"
      />
      <path d="M40.396 6.53101H38.396V13.531H40.396V6.53101Z" fill="white" />
      <path d="M39.396 7.53101V12.531V7.53101Z" stroke="#535353" strokeWidth="2" />
    </svg>
  );
}

export function IconBatteryCharging({ className }: Props) {
  return (
    <svg
      width="45"
      height="23"
      viewBox="0 0 45 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M39.999 4.974H7.66903C6.56446 4.974 5.66903 5.86943 5.66903 6.974V19.15C5.66903 20.2546 6.56446 21.15 7.66903 21.15H39.999C41.1036 21.15 41.999 20.2546 41.999 19.15V6.974C41.999 5.86943 41.1036 4.974 39.999 4.974Z"
        stroke="#535353"
        strokeWidth="2"
      />
      <path d="M44.999 9.56201H42.999V16.562H44.999V9.56201Z" fill="white" />
      <path d="M43.999 10.562V15.562V10.562Z" stroke="#535353" strokeWidth="2" />
      <path
        d="M22.834 7.974H9.66903C9.11674 7.974 8.66903 8.42171 8.66903 8.974V17.15C8.66903 17.7023 9.11674 18.15 9.66903 18.15H22.834C23.3863 18.15 23.834 17.7023 23.834 17.15V8.974C23.834 8.42171 23.3863 7.974 22.834 7.974Z"
        fill="#82B8E2"
      />
      <path
        d="M1.60413 7.90503L1.60413 4.00503L9.73513 4.00503V7.90503C9.73513 8.43546 9.52441 8.94417 9.14934 9.31924C8.77427 9.69432 8.26556 9.90503 7.73513 9.90503H3.60413C3.07369 9.90503 2.56499 9.69432 2.18991 9.31924C1.81484 8.94417 1.60413 8.43546 1.60413 7.90503V7.90503Z"
        fill="white"
        stroke="white"
        strokeWidth="3"
      />
      <path d="M4.36813 4.24403V0.879028" stroke="white" strokeWidth="4" />
      <path d="M7.27612 4.24403V0.879028" stroke="white" strokeWidth="4" />
      <path d="M5.66907 22.323V10.323" stroke="white" strokeWidth="6" />
      <path
        d="M2.60413 7.90601L2.60413 5.00601H8.73513V7.90601C8.73513 8.17122 8.62977 8.42558 8.44223 8.61311C8.2547 8.80065 8.00034 8.90601 7.73513 8.90601H3.60413C3.33891 8.90601 3.08456 8.80065 2.89702 8.61311C2.70948 8.42558 2.60413 8.17122 2.60413 7.90601V7.90601Z"
        stroke="#535353"
        strokeWidth="2"
      />
      <path d="M4.36813 4.24403V0.879028" stroke="#535353" strokeWidth="2" />
      <path d="M7.27612 4.24403V0.879028" stroke="#535353" strokeWidth="2" />
      <path d="M5.66907 22.323V9.15002" stroke="#535353" strokeWidth="2" />
    </svg>
  );
}

export function IconBatteryCharged({ className }: Props) {
  return (
    <svg
      width="45"
      height="22"
      viewBox="0 0 45 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M40.396 4.41797H8.066C6.96143 4.41797 6.066 5.3134 6.066 6.41797V18.594C6.066 19.6985 6.96143 20.594 8.066 20.594H40.396C41.5006 20.594 42.396 19.6985 42.396 18.594V6.41797C42.396 5.3134 41.5006 4.41797 40.396 4.41797Z"
        stroke="#535353"
        strokeWidth="2"
      />
      <path d="M45.396 9.00598H43.396V16.006H45.396V9.00598Z" fill="white" />
      <path d="M44.396 10.006V15.006V10.006Z" stroke="#535353" strokeWidth="2" />
      <path
        d="M38.066 7.41797H10.066C9.51372 7.41797 9.066 7.86568 9.066 8.41797V16.594C9.066 17.1463 9.51372 17.594 10.066 17.594H38.066C38.6183 17.594 39.066 17.1463 39.066 16.594V8.41797C39.066 7.86568 38.6183 7.41797 38.066 7.41797Z"
        fill="#535353"
      />
      <path
        d="M2.0011 7.349L2.0011 3.449L10.1321 3.449V7.349C10.1321 7.87943 9.92139 8.38814 9.54631 8.76321C9.17124 9.13829 8.66253 9.349 8.1321 9.349H4.0011C3.47067 9.349 2.96196 9.13829 2.58689 8.76321C2.21181 8.38814 2.0011 7.87943 2.0011 7.349H2.0011Z"
        fill="white"
        stroke="white"
        strokeWidth="3"
      />
      <path d="M4.7651 3.688V0.322998" stroke="white" strokeWidth="4" />
      <path d="M7.6731 3.688V0.322998" stroke="white" strokeWidth="4" />
      <path d="M6.06604 21.767V9.76697" stroke="white" strokeWidth="6" />
      <path
        d="M3.0011 7.34998L3.0011 4.44998H9.1321V7.34998C9.1321 7.61519 9.02674 7.86955 8.83921 8.05708C8.65167 8.24462 8.39732 8.34998 8.1321 8.34998H4.0011C3.73588 8.34998 3.48153 8.24462 3.29399 8.05708C3.10646 7.86955 3.0011 7.61519 3.0011 7.34998V7.34998Z"
        stroke="#535353"
        strokeWidth="2"
      />
      <path d="M4.7651 3.688V0.322998" stroke="#535353" strokeWidth="2" />
      <path d="M7.6731 3.688V0.322998" stroke="#535353" strokeWidth="2" />
      <path d="M6.06604 21.767V8.59399" stroke="#535353" strokeWidth="2" />
    </svg>
  );
}

export function IconDashboard({ className }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21 19V5C20.9984 4.47005 20.7872 3.96227 20.4125 3.58753C20.0377 3.2128 19.5299 3.00158 19 3L5 3C4.47005 3.00158 3.96227 3.2128 3.58753 3.58753C3.2128 3.96227 3.00158 4.47005 3 5V19C3.00158 19.5299 3.2128 20.0377 3.58753 20.4125C3.96227 20.7872 4.47005 20.9984 5 21H19C19.5299 20.9984 20.0377 20.7872 20.4125 20.4125C20.7872 20.0377 20.9984 19.5299 21 19ZM5 5L19 5V11L5 11V5ZM5 19L5 13L10.961 13L10.961 19H5ZM12.961 19L12.961 13H19V19H12.961Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconExpand({ className }: Props) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z"
        fill="none"
      />
      <path d="M8.49902 20L15.999 12.5L23.499 20" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
  );
}

export function IconHelp({ className }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11 18H13V16H11V18ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C19.9971 14.1208 19.1533 16.154 17.6536 17.6536C16.154 19.1533 14.1208 19.9971 12 20ZM12 6C10.9391 6 9.92172 6.42143 9.17158 7.17157C8.42143 7.92172 8 8.93913 8 10H10C10 9.46957 10.2107 8.96086 10.5858 8.58579C10.9609 8.21071 11.4696 8 12 8C12.5304 8 13.0391 8.21071 13.4142 8.58579C13.7893 8.96086 14 9.46957 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 8.93913 15.5786 7.92172 14.8284 7.17157C14.0783 6.42143 13.0609 6 12 6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconIv2goOutline({ className }: Props) {
  return (
    <svg
      width="85"
      height="144"
      viewBox="0 0 85 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M70.866 1H8.13C4.19221 1 1 4.19221 1 8.13V135.327C1 139.265 4.19221 142.457 8.13 142.457H70.866C74.8038 142.457 77.996 139.265 77.996 135.327V8.13C77.996 4.19221 74.8038 1 70.866 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M74.4141 25.1738V133.747C74.4141 135.107 73.8736 136.412 72.9115 137.374C71.9495 138.336 70.6446 138.877 69.2841 138.877H9.71407C8.35351 138.877 7.04866 138.336 6.0866 137.374C5.12454 136.412 4.58406 135.107 4.58406 133.747V25.1738L74.4141 25.1738Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15.4785 1H22.4555V19.063C22.4553 19.3114 22.3564 19.5496 22.1808 19.7253C22.0051 19.9009 21.7669 19.9997 21.5185 20H16.4165C16.1679 20 15.9295 19.9013 15.7536 19.7256C15.5777 19.5499 15.4788 19.3116 15.4785 19.063V1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.4555 8.16406H16.4785C15.9262 8.16406 15.4785 8.61178 15.4785 9.16406V19.0021C15.4785 19.5543 15.9262 20.0021 16.4785 20.0021H21.4555C22.0078 20.0021 22.4555 19.5543 22.4555 19.0021V9.16406C22.4555 8.61178 22.0078 8.16406 21.4555 8.16406Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M63.3698 5.61523H49.7578C48.6532 5.61523 47.7578 6.51066 47.7578 7.61523V18.0012C47.7578 19.1058 48.6532 20.0012 49.7578 20.0012H63.3698C64.4744 20.0012 65.3698 19.1058 65.3698 18.0012V7.61523C65.3698 6.51066 64.4744 5.61523 63.3698 5.61523Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M41.8342 126.605H37.1622C36.5845 126.605 36.1162 127.074 36.1162 127.651V135.407C36.1162 135.985 36.5845 136.453 37.1622 136.453H41.8342C42.4119 136.453 42.8802 135.985 42.8802 135.407V127.651C42.8802 127.074 42.4119 126.605 41.8342 126.605Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M82.5341 4.58008H78.8281C78.3681 4.58008 77.9951 4.95302 77.9951 5.41308V21.6531C77.9951 22.1131 78.3681 22.4861 78.8281 22.4861H82.5341C82.9942 22.4861 83.3671 22.1131 83.3671 21.6531V5.41308C83.3671 4.95302 82.9942 4.58008 82.5341 4.58008Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function IconIv2goOutlineWithCurtain({ className }: Props) {
  return (
    <svg
      width="85"
      height="144"
      viewBox="0 0 85 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M70.866 1.54297H8.13C4.19221 1.54297 1 4.73518 1 8.67297V135.87C1 139.808 4.19221 143 8.13 143H70.866C74.8038 143 77.996 139.808 77.996 135.87V8.67297C77.996 4.73518 74.8038 1.54297 70.866 1.54297Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M74.4141 25.7168V134.29C74.4141 135.65 73.8736 136.955 72.9115 137.917C71.9495 138.879 70.6446 139.42 69.2841 139.42H9.71407C8.35351 139.42 7.04866 138.879 6.0866 137.917C5.12454 136.955 4.58406 135.65 4.58406 134.29V25.7168L74.4141 25.7168Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15.4785 1.54297H22.4555V19.606C22.4553 19.8544 22.3564 20.0926 22.1808 20.2682C22.0051 20.4439 21.7669 20.5427 21.5185 20.543H16.4165C16.1679 20.543 15.9295 20.4443 15.7536 20.2686C15.5777 20.0929 15.4788 19.8546 15.4785 19.606V1.54297Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.4555 8.70703H16.4785C15.9262 8.70703 15.4785 9.15475 15.4785 9.70703V19.545C15.4785 20.0973 15.9262 20.545 16.4785 20.545H21.4555C22.0078 20.545 22.4555 20.0973 22.4555 19.545V9.70703C22.4555 9.15475 22.0078 8.70703 21.4555 8.70703Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M63.3698 6.1582H49.7578C48.6532 6.1582 47.7578 7.05363 47.7578 8.1582V18.5442C47.7578 19.6488 48.6532 20.5442 49.7578 20.5442H63.3698C64.4744 20.5442 65.3698 19.6488 65.3698 18.5442V8.1582C65.3698 7.05363 64.4744 6.1582 63.3698 6.1582Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M65.3709 41.2012H13.6289V133.765H65.3709V41.2012Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M41.8342 127.148H37.1622C36.5845 127.148 36.1162 127.617 36.1162 128.194V135.95C36.1162 136.528 36.5845 136.996 37.1622 136.996H41.8342C42.4119 136.996 42.8802 136.528 42.8802 135.95V128.194C42.8802 127.617 42.4119 127.148 41.8342 127.148Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M82.5341 5.12305H78.8281C78.3681 5.12305 77.9951 5.49599 77.9951 5.95605V22.196C77.9951 22.6561 78.3681 23.029 78.8281 23.029H82.5341C82.9942 23.029 83.3671 22.6561 83.3671 22.196V5.95605C83.3671 5.49599 82.9942 5.12305 82.5341 5.12305Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M71.8477 25.7168H76.2667C76.494 25.7168 76.7191 25.7616 76.9291 25.8486C77.1391 25.9356 77.3299 26.0631 77.4907 26.2238C77.6514 26.3845 77.7789 26.5754 77.8659 26.7854C77.9529 26.9954 77.9977 27.2205 77.9977 27.4478V37.3558H71.8477V25.7168Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M7.0332 25.7168H10.7832V43.5168C10.7832 43.782 10.6778 44.0364 10.4903 44.2239C10.3028 44.4114 10.0484 44.5168 9.7832 44.5168H8.0332C7.76799 44.5168 7.51363 44.4114 7.3261 44.2239C7.13856 44.0364 7.0332 43.782 7.0332 43.5168V25.7168Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M68.0947 25.7168H71.8447V43.5168C71.8447 43.782 71.7394 44.0364 71.5518 44.2239C71.3643 44.4114 71.1099 44.5168 70.8447 44.5168H69.0947C68.8295 44.5168 68.5752 44.4114 68.3876 44.2239C68.2001 44.0364 68.0947 43.782 68.0947 43.5168V25.7168Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M68.0962 25.7168H10.7822V41.2008H68.0962V25.7168Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M2.731 25.7168H7.031V37.3558H1V27.4478C1 26.9887 1.18237 26.5484 1.507 26.2238C1.83162 25.8992 2.27191 25.7168 2.731 25.7168V25.7168Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function IconLogo({ className }: Props) {
  return (
    <svg
      width="91"
      height="21"
      viewBox="0 0 91 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.703 0.791992L16.879 14.178L23.056 0.791992H27.165L18.265 19.838H15.519L6.59399 0.791992H10.703Z"
        fill="currentColor"
      />
      <path d="M4.23808 6.55005H0.809082V19.838H4.23808V6.55005Z" fill="currentColor" />
      <path
        d="M4.546 2.81499C4.546 3.2151 4.42735 3.60623 4.20506 3.93891C3.98277 4.27159 3.66682 4.53088 3.29717 4.684C2.92751 4.83712 2.52076 4.87718 2.12833 4.79912C1.73591 4.72106 1.37545 4.52839 1.09252 4.24547C0.809602 3.96255 0.61693 3.60208 0.538872 3.20966C0.460814 2.81724 0.500877 2.41048 0.653993 2.04082C0.807109 1.67117 1.0664 1.35522 1.39908 1.13293C1.73176 0.910639 2.12289 0.791992 2.523 0.791992C3.05953 0.791992 3.57409 1.00513 3.95348 1.38452C4.33286 1.7639 4.546 2.27846 4.546 2.81499"
        fill="currentColor"
      />
      <path
        d="M77.8821 0C75.8422 0 73.8481 0.604905 72.152 1.73822C70.4558 2.87154 69.1339 4.48237 68.3532 6.367C67.5726 8.25164 67.3683 10.3254 67.7663 12.3262C68.1643 14.3269 69.1466 16.1647 70.589 17.6071C72.0315 19.0495 73.8693 20.0319 75.87 20.4298C77.8707 20.8278 79.9445 20.6235 81.8291 19.8429C83.7137 19.0623 85.3246 17.7403 86.4579 16.0442C87.5912 14.348 88.1961 12.3539 88.1961 10.314C88.1961 8.95955 87.9293 7.61836 87.411 6.367C86.8927 5.11565 86.133 3.97864 85.1752 3.0209C84.2175 2.06316 83.0805 1.30343 81.8291 0.785106C80.5778 0.266779 79.2366 0 77.8821 0M77.8821 17.193C76.5216 17.193 75.1916 16.7896 74.0603 16.0337C72.9291 15.2778 72.0474 14.2035 71.5267 12.9465C71.0061 11.6895 70.8699 10.3064 71.1353 8.97197C71.4007 7.63758 72.0559 6.41186 73.0179 5.44981C73.98 4.48777 75.2057 3.83261 76.5401 3.56718C77.8745 3.30175 79.2576 3.43798 80.5146 3.95863C81.7716 4.47929 82.8459 5.36099 83.6018 6.49223C84.3577 7.62348 84.7611 8.95346 84.7611 10.314C84.7611 12.1384 84.0364 13.8881 82.7463 15.1782C81.4563 16.4683 79.7065 17.193 77.8821 17.193"
        fill="currentColor"
      />
      <path
        d="M64.831 11.572H55.874V15.14H59.501C58.4585 16.1806 57.107 16.8557 55.6489 17.0643C54.1907 17.2728 52.7042 17.0037 51.4117 16.2971C50.1192 15.5906 49.0903 14.4845 48.4787 13.1445C47.8671 11.8044 47.7059 10.3024 48.019 8.86306C48.3322 7.42373 49.1029 6.12447 50.216 5.15964C51.329 4.19481 52.7245 3.61627 54.1937 3.51056C55.6629 3.40486 57.1269 3.77767 58.3666 4.57323C59.6063 5.36879 60.5551 6.54433 61.071 7.92401H64.624C64.1039 5.75974 62.892 3.82421 61.1721 2.41117C59.4522 0.998123 57.3184 0.18471 55.0943 0.0943689C52.8702 0.00402778 50.6774 0.641691 48.8486 1.91059C47.0198 3.17948 45.6549 5.01034 44.9609 7.1253C44.267 9.24027 44.2819 11.5239 45.0035 13.6296C45.7251 15.7353 47.1139 17.5481 48.9591 18.7929C50.8044 20.0378 53.0054 20.6467 55.2281 20.5272C57.4508 20.4077 59.5738 19.5665 61.275 18.131V20.542H64.848V11.572H64.831Z"
        fill="currentColor"
      />
      <path
        d="M86.366 2.26098C86.366 1.76794 86.5618 1.2951 86.9105 0.946466C87.2591 0.597836 87.7319 0.401978 88.225 0.401978C88.718 0.401978 89.1909 0.597836 89.5395 0.946466C89.8881 1.2951 90.084 1.76794 90.084 2.26098C90.084 2.75401 89.8881 3.22686 89.5395 3.57549C89.1909 3.92412 88.718 4.11998 88.225 4.11998C87.7319 4.11998 87.2591 3.92412 86.9105 3.57549C86.5618 3.22686 86.366 2.75401 86.366 2.26098M89.753 2.26098C89.753 1.85559 89.5919 1.46681 89.3053 1.18016C89.0186 0.893515 88.6299 0.732478 88.2245 0.732478C87.8191 0.732478 87.4303 0.893515 87.1437 1.18016C86.857 1.46681 86.696 1.85559 86.696 2.26098C86.6908 2.46499 86.7264 2.66799 86.8009 2.858C86.8754 3.04801 86.9871 3.22119 87.1296 3.36733C87.272 3.51347 87.4423 3.62962 87.6303 3.70892C87.8184 3.78822 88.0204 3.82908 88.2245 3.82908C88.4286 3.82908 88.6306 3.78822 88.8186 3.70892C89.0067 3.62962 89.1769 3.51347 89.3194 3.36733C89.4618 3.22119 89.5736 3.04801 89.6481 2.858C89.7225 2.66799 89.7582 2.46499 89.753 2.26098M87.573 3.28298C87.5638 3.28411 87.5545 3.28313 87.5457 3.28012C87.5369 3.2771 87.529 3.27212 87.5224 3.26557C87.5158 3.25901 87.5109 3.25105 87.5078 3.24228C87.5048 3.23352 87.5038 3.22418 87.505 3.21498V1.28798C87.5038 1.27878 87.5048 1.26944 87.5078 1.26067C87.5109 1.25191 87.5158 1.24394 87.5224 1.23739C87.529 1.23083 87.5369 1.22586 87.5457 1.22284C87.5545 1.21982 87.5638 1.21884 87.573 1.21998H88.352C88.8 1.21998 89.063 1.44398 89.063 1.83298C89.0677 1.96036 89.0301 2.08572 88.9561 2.18953C88.8821 2.29334 88.7759 2.36979 88.654 2.40698L89.072 3.21498C89.092 3.25398 89.072 3.28298 89.033 3.28298H88.76C88.74 3.28292 88.7206 3.2762 88.7048 3.26389C88.6891 3.25157 88.6779 3.23437 88.673 3.21498L88.284 2.45598H87.913C87.884 2.45598 87.874 2.46598 87.874 2.49498V3.21998C87.8751 3.22918 87.8741 3.23852 87.8711 3.24728C87.8681 3.25605 87.8631 3.26401 87.8566 3.27057C87.85 3.27712 87.842 3.2821 87.8333 3.28512C87.8245 3.28813 87.8152 3.28911 87.806 3.28798L87.573 3.28298ZM88.693 1.83298C88.693 1.64798 88.586 1.55098 88.352 1.55098H87.914C87.885 1.55098 87.875 1.56098 87.875 1.58998V2.08998C87.8743 2.09525 87.8749 2.10061 87.8766 2.10564C87.8783 2.11066 87.8812 2.11523 87.885 2.11899C87.8887 2.12275 87.8933 2.1256 87.8983 2.12733C87.9033 2.12906 87.9087 2.12962 87.914 2.12898H88.352C88.585 2.12898 88.693 2.02198 88.693 1.83698"
        fill="currentColor"
      />
      <path
        d="M40.7071 10.6789C40.7641 10.6019 40.8201 10.5249 40.8751 10.4469C40.9104 10.3969 40.9437 10.3463 40.9751 10.2949C41.0271 10.2169 41.0774 10.1379 41.1261 10.0579L41.1641 9.99594L41.1991 9.93195C41.3063 9.73752 41.4024 9.5372 41.4871 9.33195C41.5671 9.13728 41.6374 8.93928 41.6981 8.73795C41.7274 8.63995 41.7547 8.53995 41.7801 8.43795C41.8214 8.27461 41.8567 8.11028 41.8861 7.94495C41.9214 7.74828 41.9487 7.55061 41.9681 7.35195C41.9874 7.15328 41.9987 6.95328 42.0021 6.75195V6.38295C42.0021 6.36395 42.0021 6.34395 42.0021 6.32495C41.9885 5.91043 41.937 5.49804 41.8481 5.09295C41.7562 4.67449 41.6222 4.26641 41.4481 3.87495C41.2697 3.4763 41.0498 3.09755 40.7921 2.74495C40.5348 2.39309 40.2423 2.0684 39.9191 1.77595L39.8251 1.69095L39.7251 1.61295C39.3879 1.35072 39.0278 1.11944 38.6491 0.921945C38.2729 0.726075 37.8804 0.563134 37.4761 0.434945C37.079 0.309141 36.6728 0.214192 36.2611 0.150945C35.8555 0.0886651 35.4463 0.0529225 35.0361 0.0439453H34.9561H34.8761C34.4511 0.0529613 34.0272 0.090042 33.6071 0.154945C33.1818 0.220859 32.7622 0.319485 32.3521 0.449945C31.9354 0.581447 31.5309 0.748737 31.1431 0.949945C30.7525 1.15456 30.3813 1.39421 30.0341 1.66595L29.9211 1.75395L29.8211 1.85395C29.4609 2.1886 29.1413 2.56452 28.8691 2.97395C28.605 3.37246 28.3854 3.79866 28.2141 4.24495C28.05 4.6731 27.9264 5.1157 27.8451 5.56695C27.7667 6.00287 27.7219 6.44416 27.7111 6.88695V8.17095H31.1201V6.97895C31.1028 6.49496 31.1844 6.01253 31.3599 5.56118C31.5355 5.10982 31.8013 4.69904 32.1411 4.35395C32.9562 3.75143 33.9476 3.43504 34.9611 3.45395C35.9219 3.43558 36.8621 3.73431 37.6361 4.30395C37.9362 4.57408 38.1769 4.9036 38.343 5.27163C38.5091 5.63966 38.597 6.03818 38.6011 6.44195V6.69195C38.6024 7.24499 38.4728 7.79051 38.2231 8.28395C38.1581 8.39095 38.0931 8.48395 37.9831 8.63395C37.5813 9.15167 37.1357 9.63379 36.6511 10.0749C36.2881 10.4029 35.9391 10.7189 35.3721 11.2139C32.8611 13.3139 30.1321 15.5849 27.4031 17.8599V20.5449H42.0801V17.1179H33.6121L37.5561 13.8279L37.5851 13.8029L37.6141 13.7779C37.8641 13.5593 38.1127 13.3396 38.3601 13.1189C38.5561 12.9436 38.7517 12.7676 38.9471 12.5909C39.2611 12.3029 39.5651 12.0019 39.8551 11.6909C40.0017 11.5323 40.1451 11.3706 40.2851 11.2059C40.4251 11.0413 40.5661 10.8659 40.7081 10.6799"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconLogout({ className }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17 8L15.59 9.41L17.17 11H9V13H17.17L15.59 14.58L17 16L21 12L17 8ZM5 5H12V3H5C4.47005 3.00158 3.96227 3.2128 3.58753 3.58753C3.2128 3.96227 3.00158 4.47005 3 5V19C3.00158 19.5299 3.2128 20.0377 3.58753 20.4125C3.96227 20.7872 4.47005 20.9984 5 21H12V19H5V5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconNotifications({ className }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 22C12.5299 21.9984 13.0377 21.7872 13.4125 21.4125C13.7872 21.0377 13.9984 20.5299 14 20H10C10.0016 20.5299 10.2128 21.0377 10.5875 21.4125C10.9623 21.7872 11.4701 21.9984 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.60218 13.342 3.22064 13.0607 2.93934C12.7794 2.65804 12.3978 2.5 12 2.5C11.6022 2.5 11.2206 2.65804 10.9393 2.93934C10.658 3.22064 10.5 3.60218 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconRoom({ className }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 2C10.1435 2 8.36301 2.7375 7.05025 4.05025C5.7375 5.36301 5 7.14348 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 7.14348 18.2625 5.36301 16.9497 4.05025C15.637 2.7375 13.8565 2 12 2ZM7 9C7 7.67392 7.52678 6.40215 8.46447 5.46447C9.40215 4.52678 10.6739 4 12 4C13.3261 4 14.5979 4.52678 15.5355 5.46447C16.4732 6.40215 17 7.67392 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z"
        fill="currentColor"
      />
      <path
        d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconSettings({ className }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.4299 12.98C19.4738 12.6552 19.4972 12.3279 19.4999 12C19.4972 11.6722 19.4738 11.3449 19.4299 11.02L21.5399 9.37005C21.633 9.29528 21.6963 9.18965 21.7184 9.07226C21.7404 8.95487 21.7196 8.83347 21.6599 8.73005L19.6599 5.27005C19.6154 5.193 19.5512 5.12922 19.4739 5.08527C19.3965 5.04132 19.3088 5.01881 19.2199 5.02005C19.1619 5.0194 19.1042 5.02957 19.0499 5.05005L16.5599 6.05005C16.043 5.6492 15.4746 5.31958 14.8699 5.07005L14.4899 2.42005C14.4733 2.30239 14.4144 2.19481 14.3242 2.11748C14.234 2.04016 14.1187 1.9984 13.9999 2.00005H9.99989C9.88109 1.9984 9.76576 2.04016 9.67555 2.11748C9.58534 2.19481 9.52644 2.30239 9.50989 2.42005L9.12989 5.07005C8.52715 5.32347 7.95923 5.6528 7.43989 6.05005L4.94989 5.05005C4.89191 5.03038 4.83112 5.02025 4.76989 5.02005C4.68264 5.02057 4.59704 5.04393 4.5216 5.08778C4.44616 5.13164 4.38352 5.19448 4.33989 5.27005L2.33989 8.73005C2.27869 8.83308 2.25711 8.95489 2.2792 9.07268C2.30128 9.19047 2.36552 9.29618 2.45989 9.37005L4.56989 11.02C4.52633 11.345 4.50295 11.6722 4.49989 12C4.50295 12.3278 4.52633 12.6551 4.56989 12.98L2.45989 14.63C2.36675 14.7048 2.30344 14.8104 2.28143 14.9278C2.25942 15.0452 2.28016 15.1666 2.33989 15.27L4.33989 18.73C4.38436 18.8071 4.44858 18.8709 4.52593 18.9148C4.60327 18.9588 4.69094 18.9813 4.77989 18.98C4.83793 18.9807 4.89558 18.9705 4.94989 18.95L7.43989 17.95C7.95681 18.3509 8.52523 18.6805 9.12989 18.93L9.50989 21.58C9.52644 21.6977 9.58534 21.8053 9.67555 21.8826C9.76576 21.9599 9.88109 22.0017 9.99989 22H13.9999C14.1187 22.0017 14.234 21.9599 14.3242 21.8826C14.4144 21.8053 14.4733 21.6977 14.4899 21.58L14.8699 18.93C15.4726 18.6766 16.0406 18.3473 16.5599 17.95L19.0499 18.95C19.1079 18.9697 19.1687 18.9798 19.2299 18.98C19.3172 18.9795 19.4028 18.9562 19.4782 18.9123C19.5536 18.8685 19.6163 18.8056 19.6599 18.73L21.6599 15.27C21.7196 15.1666 21.7404 15.0452 21.7184 14.9278C21.6963 14.8104 21.633 14.7048 21.5399 14.63L19.4299 12.98ZM17.4499 11.27C17.4832 11.512 17.4999 11.7559 17.4999 12C17.4999 12.21 17.4799 12.43 17.4499 12.73L17.3099 13.86L18.1999 14.56L19.2799 15.4L18.5799 16.61L17.3099 16.1L16.2699 15.68L15.3699 16.36C14.985 16.6541 14.5651 16.8993 14.1199 17.09L13.0599 17.52L12.8999 18.65L12.6999 20H11.2999L11.1099 18.65L10.9499 17.52L9.88989 17.09C9.45178 16.9058 9.03854 16.6673 8.65989 16.38L7.74989 15.68L6.68989 16.11L5.41989 16.62L4.71989 15.41L5.79989 14.57L6.68989 13.87L6.54989 12.74C6.51989 12.43 6.49989 12.2 6.49989 12C6.49989 11.8 6.51989 11.57 6.54989 11.27L6.68989 10.14L5.79989 9.44005L4.71989 8.60005L5.41989 7.39005L6.68989 7.90005L7.72989 8.32005L8.62989 7.64005C9.01477 7.34596 9.43464 7.10076 9.87989 6.91005L10.9399 6.48005L11.0999 5.35005L11.2999 4.00005H12.6899L12.8799 5.35005L13.0399 6.48005L14.0999 6.91005C14.538 7.09426 14.9512 7.3328 15.3299 7.62005L16.2399 8.32005L17.2999 7.89005L18.5699 7.38005L19.2699 8.59005L18.1999 9.44005L17.3099 10.14L17.4499 11.27ZM11.9999 8.00005C11.2088 8.00005 10.4354 8.23464 9.77761 8.67417C9.11982 9.11369 8.60712 9.73841 8.30437 10.4693C8.00162 11.2002 7.92241 12.0045 8.07675 12.7804C8.23109 13.5563 8.61206 14.2691 9.17147 14.8285C9.73088 15.3879 10.4436 15.7688 11.2195 15.9232C11.9955 16.0775 12.7997 15.9983 13.5306 15.6956C14.2615 15.3928 14.8862 14.8801 15.3258 14.2223C15.7653 13.5645 15.9999 12.7912 15.9999 12C15.9999 10.9392 15.5785 9.92176 14.8283 9.17162C14.0782 8.42147 13.0608 8.00005 11.9999 8.00005ZM11.9999 14C11.6043 14 11.2177 13.8827 10.8888 13.663C10.5599 13.4432 10.3035 13.1309 10.1521 12.7654C10.0008 12.4 9.96115 11.9978 10.0383 11.6099C10.1155 11.2219 10.306 10.8655 10.5857 10.5858C10.8654 10.3061 11.2217 10.1156 11.6097 10.0385C11.9977 9.96131 12.3998 10.0009 12.7653 10.1523C13.1307 10.3037 13.4431 10.56 13.6628 10.8889C13.8826 11.2178 13.9999 11.6045 13.9999 12C13.9983 12.53 13.7871 13.0378 13.4124 13.4125C13.0376 13.7872 12.5298 13.9985 11.9999 14Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconPoweredBy({ className }: Props) {
  return (
    <svg
      width="110"
      height="14"
      viewBox="0 0 110 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M77.9369 7.03425C77.9666 7.69101 77.8592 8.34675 77.6214 8.95967C77.3836 9.57259 77.0207 10.1292 76.5558 10.5941C76.0909 11.059 75.5343 11.4219 74.9214 11.6597C74.3084 11.8975 73.6527 12.005 72.9959 11.9752C72.3401 12.0047 71.6853 11.8969 71.0735 11.6588C70.4616 11.4206 69.9063 11.0574 69.4429 10.5923C68.9795 10.1272 68.6183 9.57055 68.3824 8.95787C68.1465 8.34518 68.0411 7.69 68.0729 7.03425C68.0453 6.38145 68.1528 5.72998 68.3887 5.12067C68.6246 4.51136 68.9839 3.95735 69.4439 3.49337C69.9039 3.02939 70.4548 2.66545 71.0621 2.42434C71.6694 2.18324 72.3199 2.07018 72.9729 2.09225C73.6293 2.06848 74.2836 2.17989 74.8952 2.41955C75.5067 2.65921 76.0625 3.02201 76.528 3.48543C76.9935 3.94885 77.3587 4.503 77.6011 5.11348C77.8435 5.72396 77.9578 6.37774 77.9369 7.03425M70.4179 7.03425C70.3873 7.39027 70.4313 7.74877 70.5472 8.08681C70.663 8.42485 70.8481 8.73499 71.0907 8.9974C71.3332 9.25981 71.6279 9.46872 71.9558 9.61075C72.2837 9.75278 72.6376 9.82482 72.9949 9.82225C73.3523 9.82498 73.7062 9.75305 74.0342 9.61106C74.3621 9.46907 74.6567 9.26015 74.8992 8.99769C75.1417 8.73522 75.3268 8.425 75.4424 8.0869C75.5581 7.74879 75.6019 7.39025 75.5709 7.03425C75.5885 6.68023 75.5356 6.32625 75.4152 5.99285C75.2949 5.65946 75.1095 5.3533 74.8698 5.09215C74.6302 4.831 74.341 4.62006 74.0192 4.47158C73.6973 4.32311 73.3492 4.24006 72.9949 4.22725C72.6373 4.22928 72.2839 4.30507 71.9569 4.44988C71.6299 4.5947 71.3363 4.80541 71.0944 5.06887C70.8525 5.33232 70.6676 5.64285 70.5512 5.98102C70.4348 6.31919 70.3895 6.67774 70.4179 7.03425"
        fill="currentColor"
      />
      <path
        d="M84.496 4.80324C84.1813 4.51243 83.8114 4.28779 83.4082 4.14264C83.005 3.99749 82.5768 3.93478 82.149 3.95825C81.034 3.95825 80.419 4.30424 80.419 4.90024C80.419 5.51524 80.976 5.86125 82.188 5.93925C83.976 6.05425 86.245 6.45825 86.245 8.97625C86.245 10.6492 84.88 12.0922 82.169 12.0922C81.3586 12.1482 80.5459 12.0257 79.788 11.7334C79.0302 11.441 78.3458 10.9859 77.783 10.4002L78.937 8.72725C79.8399 9.53498 80.9963 10.0025 82.207 10.0492C83.092 10.0682 83.918 9.60725 83.918 8.91525C83.918 8.26125 83.379 7.99225 82.034 7.91525C80.244 7.78025 78.11 7.12625 78.11 4.97225C78.11 2.78025 80.379 2.01125 82.11 2.01125C83.4576 1.92158 84.7856 2.37085 85.802 3.26025L84.496 4.80324Z"
        fill="currentColor"
      />
      <path
        d="M94.4989 2.28225H96.7489V11.7623H94.5379L94.4229 10.3823C94.0945 10.8994 93.6395 11.3242 93.1011 11.6165C92.5626 11.9087 91.9585 12.0587 91.3459 12.0523C88.5389 12.0723 86.4609 10.3413 86.4609 7.01425C86.4094 6.35119 86.5017 5.68482 86.7317 5.06076C86.9616 4.43671 87.3237 3.86971 87.7931 3.39858C88.2625 2.92746 88.8282 2.56333 89.4514 2.33113C90.0746 2.09893 90.7406 2.00414 91.4039 2.05325C91.9965 2.03116 92.5848 2.16086 93.1132 2.43003C93.6416 2.6992 94.0924 3.09892 94.4229 3.59125L94.4989 2.28225ZM88.8079 7.01225C88.7841 7.39063 88.8397 7.7698 88.9713 8.12535C89.1029 8.48091 89.3075 8.80496 89.5719 9.07665C89.8364 9.34833 90.1548 9.56162 90.5066 9.70278C90.8585 9.84395 91.236 9.90985 91.6149 9.89625C95.3069 9.89625 95.3069 4.14725 91.6149 4.14725C91.2371 4.13154 90.8602 4.19536 90.5087 4.33456C90.1571 4.47377 89.8387 4.68527 89.5741 4.95535C89.3095 5.22544 89.1045 5.5481 88.9725 5.90243C88.8406 6.25676 88.7845 6.63486 88.8079 7.01225"
        fill="currentColor"
      />
      <path
        d="M105.199 2.28231H107.449V11.7623H105.238L105.127 10.3823C104.798 10.9002 104.342 11.3255 103.803 11.6178C103.263 11.91 102.658 12.0596 102.045 12.0523C99.2379 12.0723 97.1619 10.3413 97.1619 7.01431C97.1102 6.35138 97.2024 5.68512 97.4322 5.06114C97.662 4.43716 98.0238 3.8702 98.4931 3.39907C98.9623 2.92794 99.5278 2.56377 100.151 2.3315C100.774 2.09923 101.44 2.00433 102.103 2.05331C102.696 2.03016 103.286 2.15936 103.815 2.42858C104.344 2.69781 104.796 3.0981 105.127 3.59131L105.199 2.28231ZM99.5079 7.01231C99.4842 7.39065 99.54 7.76975 99.6716 8.12524C99.8033 8.48072 100.008 8.80471 100.272 9.07636C100.537 9.34801 100.855 9.56131 101.207 9.70252C101.559 9.84374 101.936 9.90975 102.315 9.89631C106.007 9.89631 106.007 4.14731 102.315 4.14731C101.937 4.13143 101.56 4.19519 101.208 4.33445C100.856 4.47371 100.537 4.68537 100.273 4.95569C100.008 5.22602 99.8029 5.54897 99.671 5.90362C99.5391 6.25826 99.4832 6.63667 99.5069 7.01431"
        fill="currentColor"
      />
      <path
        d="M107.82 3.09821C107.818 2.97942 107.84 2.86142 107.884 2.75124C107.929 2.64107 107.995 2.54099 108.079 2.45698C108.163 2.37297 108.263 2.30676 108.373 2.2623C108.483 2.21783 108.601 2.19604 108.72 2.19821C108.839 2.19561 108.957 2.21712 109.067 2.26143C109.178 2.30574 109.278 2.37194 109.362 2.45604C109.446 2.54013 109.512 2.64038 109.557 2.75075C109.601 2.86111 109.623 2.97931 109.62 3.09821C109.622 3.21707 109.601 3.3352 109.556 3.4455C109.512 3.5558 109.446 3.656 109.362 3.74006C109.278 3.82413 109.178 3.89033 109.067 3.93469C108.957 3.97906 108.839 4.00066 108.72 3.99821C108.601 4.00024 108.483 3.97835 108.373 3.93384C108.263 3.88933 108.163 3.82311 108.079 3.73913C107.995 3.65515 107.929 3.55512 107.884 3.44501C107.84 3.3349 107.818 3.21696 107.82 3.09821M109.457 3.09821C109.46 3.00033 109.443 2.90286 109.407 2.81175C109.371 2.72064 109.317 2.63779 109.248 2.56827C109.179 2.49874 109.097 2.444 109.006 2.40737C108.915 2.37074 108.818 2.35299 108.72 2.35521C108.622 2.35271 108.524 2.37026 108.433 2.40676C108.342 2.44327 108.26 2.49798 108.19 2.56753C108.121 2.63708 108.067 2.72002 108.031 2.81127C107.995 2.90252 107.978 3.00016 107.981 3.09821C107.978 3.19652 107.995 3.29445 108.031 3.38603C108.067 3.4776 108.121 3.56092 108.19 3.63089C108.259 3.70087 108.342 3.75604 108.433 3.79306C108.524 3.83007 108.622 3.84816 108.72 3.84621C108.818 3.84816 108.916 3.83007 109.007 3.79306C109.098 3.75604 109.181 3.70087 109.25 3.63089C109.319 3.56092 109.373 3.4776 109.409 3.38603C109.445 3.29445 109.462 3.19652 109.459 3.09821M108.403 3.58821C108.399 3.58868 108.394 3.58815 108.39 3.58666C108.386 3.58517 108.382 3.58275 108.379 3.57959C108.375 3.57642 108.373 3.57259 108.372 3.56837C108.37 3.56416 108.369 3.55966 108.37 3.55521V2.62421C108.369 2.61976 108.37 2.61526 108.372 2.61104C108.373 2.60682 108.375 2.60299 108.379 2.59983C108.382 2.59666 108.386 2.59425 108.39 2.59276C108.394 2.59126 108.399 2.59074 108.403 2.59121H108.78C108.996 2.59121 109.123 2.69921 109.123 2.89121C109.125 2.95298 109.106 3.01364 109.07 3.06375C109.034 3.11385 108.982 3.15058 108.923 3.16821L109.123 3.55821C109.133 3.57721 109.123 3.59121 109.104 3.59121H108.977C108.967 3.59125 108.958 3.58801 108.95 3.58202C108.943 3.57603 108.937 3.56764 108.935 3.55821L108.747 3.18821H108.568C108.554 3.18821 108.549 3.18821 108.549 3.20721V3.55521C108.549 3.55931 108.549 3.56345 108.548 3.56738C108.546 3.5713 108.544 3.57493 108.542 3.57802C108.539 3.58112 108.536 3.58362 108.532 3.58537C108.528 3.58713 108.524 3.58809 108.52 3.58821H108.403ZM108.944 2.88821C108.944 2.79921 108.892 2.75221 108.779 2.75221H108.568C108.554 2.75221 108.549 2.75221 108.549 2.77121V3.01121C108.549 3.01378 108.549 3.01639 108.55 3.01885C108.551 3.0213 108.552 3.02353 108.554 3.02536C108.556 3.0272 108.558 3.02859 108.56 3.02943C108.563 3.03027 108.565 3.03053 108.568 3.03021H108.78C108.893 3.03021 108.945 2.97821 108.945 2.88921"
        fill="currentColor"
      />
      <path
        d="M1.40942 2.39258H5.28247C6.0481 2.39258 6.66528 2.60938 7.13403 3.04297C7.60278 3.47266 7.83716 4.07812 7.83716 4.85938C7.83716 5.53125 7.62817 6.11719 7.21021 6.61719C6.79224 7.11328 6.14966 7.36133 5.28247 7.36133H2.57544V11H1.40942V2.39258ZM6.65942 4.86523C6.65942 4.23242 6.42505 3.80273 5.9563 3.57617C5.69849 3.45508 5.34497 3.39453 4.89575 3.39453H2.57544V6.37695H4.89575C5.41919 6.37695 5.84302 6.26562 6.16724 6.04297C6.49536 5.82031 6.65942 5.42773 6.65942 4.86523ZM11.6516 10.3203C12.3508 10.3203 12.8293 10.0566 13.0872 9.5293C13.3489 8.99805 13.4797 8.4082 13.4797 7.75977C13.4797 7.17383 13.386 6.69727 13.1985 6.33008C12.9016 5.75195 12.3899 5.46289 11.6633 5.46289C11.0188 5.46289 10.55 5.70898 10.2571 6.20117C9.96411 6.69336 9.81763 7.28711 9.81763 7.98242C9.81763 8.65039 9.96411 9.20703 10.2571 9.65234C10.55 10.0977 11.0149 10.3203 11.6516 10.3203ZM11.6926 4.54297C12.5012 4.54297 13.1848 4.8125 13.7434 5.35156C14.302 5.89062 14.5813 6.68359 14.5813 7.73047C14.5813 8.74219 14.3352 9.57812 13.843 10.2383C13.3508 10.8984 12.5872 11.2285 11.552 11.2285C10.6887 11.2285 10.0032 10.9375 9.49536 10.3555C8.98755 9.76953 8.73364 8.98438 8.73364 8C8.73364 6.94531 9.00122 6.10547 9.53638 5.48047C10.0715 4.85547 10.7903 4.54297 11.6926 4.54297ZM16.3274 4.72461L17.5344 9.66992L18.759 4.72461H19.9426L21.1731 9.64062L22.4563 4.72461H23.511L21.6887 11H20.593L19.3157 6.14258L18.0793 11H16.9836L15.1731 4.72461H16.3274ZM27.1262 4.58398C27.5715 4.58398 28.0032 4.68945 28.4211 4.90039C28.8391 5.10742 29.1575 5.37695 29.3762 5.70898C29.5872 6.02539 29.7278 6.39453 29.7981 6.81641C29.8606 7.10547 29.8918 7.56641 29.8918 8.19922H25.2922C25.3118 8.83594 25.4622 9.34766 25.7434 9.73438C26.0247 10.1172 26.4602 10.3086 27.05 10.3086C27.6008 10.3086 28.0403 10.127 28.3684 9.76367C28.5559 9.55273 28.6887 9.30859 28.7668 9.03125H29.804C29.7766 9.26172 29.6848 9.51953 29.5286 9.80469C29.3762 10.0859 29.2043 10.3164 29.0129 10.4961C28.6926 10.8086 28.2961 11.0195 27.8235 11.1289C27.5696 11.1914 27.2825 11.2227 26.9622 11.2227C26.1809 11.2227 25.5188 10.9395 24.9758 10.373C24.4329 9.80273 24.1614 9.00586 24.1614 7.98242C24.1614 6.97461 24.4348 6.15625 24.9817 5.52734C25.5286 4.89844 26.2434 4.58398 27.1262 4.58398ZM28.8079 7.36133C28.7649 6.9043 28.6653 6.53906 28.509 6.26562C28.22 5.75781 27.7375 5.50391 27.0618 5.50391C26.5774 5.50391 26.1711 5.67969 25.843 6.03125C25.5149 6.37891 25.3411 6.82227 25.3215 7.36133H28.8079ZM31.2219 4.72461H32.2239V5.80859C32.3059 5.59766 32.5071 5.3418 32.8274 5.04102C33.1477 4.73633 33.5168 4.58398 33.9348 4.58398C33.9543 4.58398 33.9875 4.58594 34.0344 4.58984C34.0813 4.59375 34.1614 4.60156 34.2747 4.61328V5.72656C34.2122 5.71484 34.1536 5.70703 34.0989 5.70312C34.0481 5.69922 33.9915 5.69727 33.929 5.69727C33.3977 5.69727 32.9895 5.86914 32.7043 6.21289C32.4192 6.55273 32.2766 6.94531 32.2766 7.39062V11H31.2219V4.72461ZM37.802 4.58398C38.2473 4.58398 38.679 4.68945 39.0969 4.90039C39.5149 5.10742 39.8333 5.37695 40.052 5.70898C40.2629 6.02539 40.4036 6.39453 40.4739 6.81641C40.5364 7.10547 40.5676 7.56641 40.5676 8.19922H35.968C35.9875 8.83594 36.1379 9.34766 36.4192 9.73438C36.7004 10.1172 37.136 10.3086 37.7258 10.3086C38.2766 10.3086 38.7161 10.127 39.0442 9.76367C39.2317 9.55273 39.3645 9.30859 39.4426 9.03125H40.4797C40.4524 9.26172 40.3606 9.51953 40.2043 9.80469C40.052 10.0859 39.8801 10.3164 39.6887 10.4961C39.3684 10.8086 38.9719 11.0195 38.4993 11.1289C38.2454 11.1914 37.9583 11.2227 37.6379 11.2227C36.8567 11.2227 36.1946 10.9395 35.6516 10.373C35.1086 9.80273 34.8372 9.00586 34.8372 7.98242C34.8372 6.97461 35.1106 6.15625 35.6575 5.52734C36.2043 4.89844 36.9192 4.58398 37.802 4.58398ZM39.4836 7.36133C39.4407 6.9043 39.3411 6.53906 39.1848 6.26562C38.8958 5.75781 38.4133 5.50391 37.7375 5.50391C37.2532 5.50391 36.8469 5.67969 36.5188 6.03125C36.1907 6.37891 36.0168 6.82227 35.9973 7.36133H39.4836ZM42.5364 7.93555C42.5364 8.60742 42.679 9.16992 42.9641 9.62305C43.2493 10.0762 43.7063 10.3027 44.3352 10.3027C44.8235 10.3027 45.2239 10.0938 45.5364 9.67578C45.8528 9.25391 46.011 8.65039 46.011 7.86523C46.011 7.07227 45.8489 6.48633 45.5247 6.10742C45.2004 5.72461 44.8 5.5332 44.3235 5.5332C43.7922 5.5332 43.3606 5.73633 43.0286 6.14258C42.7004 6.54883 42.5364 7.14648 42.5364 7.93555ZM44.1243 4.61328C44.6047 4.61328 45.0071 4.71484 45.3313 4.91797C45.5188 5.03516 45.7317 5.24023 45.97 5.5332V2.36328H46.9836V11H46.0344V10.127C45.7883 10.5137 45.4973 10.793 45.1614 10.9648C44.8254 11.1367 44.4407 11.2227 44.0071 11.2227C43.3079 11.2227 42.7024 10.9297 42.1907 10.3438C41.679 9.75391 41.4231 8.9707 41.4231 7.99414C41.4231 7.08008 41.6555 6.28906 42.1204 5.62109C42.5891 4.94922 43.2571 4.61328 44.1243 4.61328ZM51.8059 2.36328H52.8313V5.48633C53.0618 5.18555 53.3372 4.95703 53.6575 4.80078C53.9778 4.64062 54.3254 4.56055 54.7004 4.56055C55.4817 4.56055 56.1145 4.83008 56.5989 5.36914C57.0872 5.9043 57.3313 6.69531 57.3313 7.74219C57.3313 8.73438 57.0911 9.55859 56.6106 10.2148C56.1301 10.8711 55.4641 11.1992 54.6125 11.1992C54.136 11.1992 53.7336 11.084 53.4055 10.8535C53.2102 10.7168 53.0012 10.498 52.7786 10.1973V11H51.8059V2.36328ZM54.5481 10.2676C55.1184 10.2676 55.5442 10.041 55.8254 9.58789C56.1106 9.13477 56.2532 8.53711 56.2532 7.79492C56.2532 7.13477 56.1106 6.58789 55.8254 6.1543C55.5442 5.7207 55.1282 5.50391 54.5774 5.50391C54.0969 5.50391 53.675 5.68164 53.3118 6.03711C52.9524 6.39258 52.7727 6.97852 52.7727 7.79492C52.7727 8.38477 52.8469 8.86328 52.9954 9.23047C53.2727 9.92188 53.7903 10.2676 54.5481 10.2676ZM62.4875 4.72461H63.6536C63.5051 5.12695 63.175 6.04492 62.6633 7.47852C62.2805 8.55664 61.9602 9.43555 61.7024 10.1152C61.093 11.7168 60.6633 12.6934 60.4133 13.0449C60.1633 13.3965 59.7336 13.5723 59.1243 13.5723C58.9758 13.5723 58.8606 13.5664 58.7786 13.5547C58.7004 13.543 58.6028 13.5215 58.4856 13.4902V12.5293C58.6692 12.5801 58.802 12.6113 58.884 12.623C58.9661 12.6348 59.0383 12.6406 59.1008 12.6406C59.2961 12.6406 59.4387 12.6074 59.5286 12.541C59.6223 12.4785 59.7004 12.4004 59.7629 12.3066C59.7825 12.2754 59.8528 12.1152 59.9739 11.8262C60.095 11.5371 60.1829 11.3223 60.2375 11.1816L57.9172 4.72461H59.1125L60.7942 9.83398L62.4875 4.72461Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconSignal({ className }: Props) {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.36801 16.468C8.54669 15.2585 9.95563 14.2972 11.5117 13.6408C13.0678 12.9844 14.7396 12.6462 16.4285 12.6462C18.1174 12.6462 19.7892 12.9844 21.3453 13.6408C22.9014 14.2972 24.3103 15.2585 25.489 16.468"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.998 11.996C3.87814 10.0964 6.11626 8.58838 8.5829 7.55921C11.0495 6.53003 13.6958 6.00012 16.3685 6.00012C19.0412 6.00012 21.6875 6.53003 24.1541 7.55921C26.6207 8.58838 28.8589 10.0964 30.739 11.996"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.169 21.131C12.6918 20.0491 14.5135 19.4679 16.3815 19.4679C18.2495 19.4679 20.0712 20.0491 21.594 21.131"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconNoSignal({ className }: Props) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.13901 4.13904L27.862 27.862"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.189 14.618C23.4176 15.2177 24.5665 15.9685 25.609 16.853"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.287 16.924C8.51013 15.0652 11.1858 13.8283 14.042 13.339"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.565 6.40908C15.7786 6.15013 19.0115 6.54133 22.0706 7.55931C25.1297 8.57729 27.9523 10.2012 30.37 12.3341"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.63 12.1961C3.71075 10.3569 6.09655 8.89494 8.68001 7.8761"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8 21.6541C12.3228 20.5722 14.1445 19.991 16.0125 19.991C17.8805 19.991 19.7022 20.5722 21.225 21.6541"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconCirclePlus({ className }: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" className={className}>
      <g id="New_plus_icon_small" transform="translate(1 1)">
        <circle
          id="Ellipse_590"
          cx="16"
          cy="16"
          r="16"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <g id="Group_2180" transform="translate(8.5 8.5)">
          <line
            id="Line_236"
            y2="15"
            transform="translate(7.5)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            id="Line_237"
            x1="15"
            transform="translate(0 7.5)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
}

export function IconCheckmark({ className }: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" className={className}>
      <g id="check_mark_icon_small" transform="translate(1 1)">
        <circle
          id="Ellipse_587"
          cx="16"
          cy="16"
          r="16"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_1347"
          d="M731.3,300.593l4.983,6.108a.69.69,0,0,0,1.177.047l7.84-13.155"
          transform="translate(-722.305 -284.593)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export function IconInfo({ className }: Props) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16 2C12.2605 2 8.74475 3.45625 6.1005 6.1005C3.45625 8.74475 2 12.2605 2 16C2 19.7395 3.45625 23.2552 6.1005 25.8995C8.74475 28.5438 12.2605 30 16 30C19.7395 30 23.2552 28.5438 25.8995 25.8995C28.5438 23.2552 30 19.7395 30 16C30 12.2605 28.5438 8.74475 25.8995 6.1005C23.2552 3.45625 19.7395 2 16 2ZM16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0Z"
        fill="currentColor"
      />
      <path d="M16 22.668V16.08" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
      <path d="M16 11.1689V11.3739" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
    </svg>
  );
}

export function IconWarning({ className }: Props) {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.9997 3.78931C15.8812 3.78931 15.7182 3.82876 15.6144 4.01671L2.05813 28.5581C1.95765 28.74 2.00604 28.896 2.06433 28.9948C2.12262 29.0935 2.23572 29.2113 2.44352 29.2113H29.556C29.7638 29.2113 29.8769 29.0936 29.9352 28.9948C29.9934 28.896 30.0418 28.74 29.9414 28.5581L16.3851 4.01672C16.2813 3.82876 16.1183 3.78931 15.9997 3.78931ZM15.9997 1.78931C16.8357 1.78931 17.6717 2.20943 18.1358 3.04967L31.692 27.5911C32.5904 29.2175 31.414 31.2113 29.556 31.2113H2.44352C0.585475 31.2113 -0.590936 29.2175 0.307464 27.5911L13.8637 3.04967C14.3278 2.20943 15.1638 1.78931 15.9997 1.78931Z"
        fill="currentColor"
      />
      <path d="M16 12.945V19.533" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
      <path d="M16 25.135V24.93" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
    </svg>
  );
}

export function IconClose({ className }: Props) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M1.5 16.5L16.5 1.5" stroke="currentColor" strokeWidth="2" />
      <path d="M1.5 1.5L16.5 16.5" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function IconSearch({ className }: Props) {
  return (
    <svg
      width="32"
      height="34"
      viewBox="0 0 32 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M27 0.685059H5C2.23858 0.685059 0 2.92363 0 5.68506V28.1851C0 30.9465 2.23858 33.1851 5 33.1851H27C29.7614 33.1851 32 30.9465 32 28.1851V5.68506C32 2.92363 29.7614 0.685059 27 0.685059Z"
        fill="none"
      />
      <path d="M18.2109 19.5259L25.9891 27.3041" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M19.2715 20.5866C22.5909 17.2671 22.5909 11.8852 19.2715 8.56576C15.952 5.24631 10.5701 5.24631 7.25064 8.56576C3.93119 11.8852 3.93119 17.2671 7.25064 20.5866C10.5701 23.906 15.952 23.906 19.2715 20.5866Z"
        fill="none"
      />
      <path
        d="M18.5642 19.8795C21.4931 16.9505 21.4931 12.2018 18.5642 9.27287C15.6353 6.34394 10.8865 6.34394 7.9576 9.27287C5.02867 12.2018 5.02867 16.9505 7.9576 19.8795C10.8865 22.8084 15.6353 22.8084 18.5642 19.8795Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconEdit({ className }: Props) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M6.76611 15.2781H16.3051" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.028 1.24901C12.1855 1.0821 12.3755 0.949117 12.5862 0.858229C12.7969 0.767341 13.024 0.720459 13.2535 0.720459C13.483 0.720459 13.7101 0.767341 13.9208 0.858229C14.1315 0.949117 14.3215 1.0821 14.479 1.24901C14.805 1.59366 14.9867 2.05008 14.9867 2.52451C14.9867 2.99894 14.805 3.45536 14.479 3.80001L4.267 14.427L1 15.277L1.817 11.877L12.028 1.24901Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
